// extracted by mini-css-extract-plugin
module.exports = {"main":"_38LmCNd-xpSCQ-7oacLZhy","titulo":"_3uvbicSBIMWd_MaYEV_zIV","buttonCont":"_2_HuszPzcAjxhZW5Qmbowv","button":"_2KAzgklFNptl-xaCY0vUzf"};